export default "__VITE_ASSET__D6Qt_pQQ__"